<template>
  <div>
    <Button
      label="RELATÓRIO"
      icon="pi pi-eye"
      class="p-button-raised p-button-secondary p-button-sm"
      @click="showPreview = true"
    />

    <Dialog
      id="preview-report"
      :visible.sync="showPreview"
      :style="{ width: $isMobile() ? '100vw' : '92vw', maxWidth: '1200px' }"
      header=""
      :modal="true"
      :closable="false"
      class="report-dialog"
    >
      <Loading :active.sync="loading" :isFullPage="false" :zIndex="9000" />

      <div class="report-header">
        <div class="report-header__left">
          <i class="pi pi-file-pdf report-header__icon"></i>
          <div>
            <h2 class="report-header__title">Preview do Relatório</h2>
          </div>
        </div>
        <button class="report-header__close" @click="showPreview = false">
          <i class="pi pi-times"></i>
        </button>
      </div>

      <div v-if="reportData" class="report-body">

        <div class="share-panel">
          <div class="share-panel__header">
            <i class="pi pi-share-alt"></i>
            <span>Enviar ao Cliente</span>
          </div>

          <div class="share-row">
            <div class="share-row__label">
              <i class="pi pi-envelope"></i>
              <span>E-mail</span>
            </div>
            <div class="share-row__input">
              <InputText
                v-model="clientData.email"
                placeholder="email@exemplo.com"
                class="share-input"
              />
            </div>
            <Button
              label="Enviar"
              icon="pi pi-send"
              class="p-button-sm share-btn share-btn--email"
              :disabled="!clientData.email"
              :loading="sendingEmail"
              @click="sendEmail"
            />
          </div>

          <div class="share-row share-row--sms">
            <div class="share-row__label">
              <i class="pi pi-comment"></i>
              <span>SMS</span>
            </div>
            <div class="share-row__inputs">
              <InputText
                v-model="clientData.mobilPhone"
                placeholder="+351 9XX XXX XXX"
                class="share-input share-input--phone"
              />
              <Textarea
                v-model="clientData.smsText"
                placeholder="Mensagem SMS..."
                :autoResize="true"
                rows="2"
                class="share-input share-input--textarea"
              />
            </div>
            <Button
              label="Enviar"
              icon="pi pi-comment"
              class="p-button-sm share-btn share-btn--sms"
              :disabled="!clientData.mobilPhone || !clientData.smsText"
              :loading="sendingSms"
              @click="sendSms"
            />
          </div>
        </div>

        <div class="pdf-preview">
          <iframe
            :src="reportData"
            class="pdf-frame"
          />
        </div>
      </div>

      <template #footer>
        <div class="report-footer">
          <Button
            label="Descarregar PDF"
            icon="pi pi-download"
            class="p-button-outlined report-footer__download"
            @click="downloadReport"
          />
          <Button
            label="Fechar"
            icon="pi pi-times"
            class="p-button-secondary"
            @click="showPreview = false"
          />
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import internalDossierService from '@/services/internalDossier.service';

export default {
  name: "PreviewInternalDossierReport",
  props: ["stamp", "report"],
  data() {
    return {
      clientData: {
        email: "",
        mobilPhone: "",
        smsText: "Olá. Foi enviado a proposta para o seu e-mail. Por favor, verifique o seu e-mail para mais detalhes."
      },
      loading: false,
      sendingEmail: false,
      sendingSms: false,
      localShow: false,
      reportData: null,
      reportBlob: null,
      showPreview: false
    };
  },
  watch: {
    async showPreview(val) {
      if (val === true) {
        await this.onDialogOpen();
      }
    },
  },
  beforeDestroy() {
    if (this.reportData) URL.revokeObjectURL(this.reportData);
  },
  methods: {
    async onDialogOpen() {
      if (this.report === 'transport_document') {
        this.clientData.smsText = 'Olá. Foi enviada a guia de transporte para o seu e-mail. Por favor, verifique o seu e-mail para mais detalhes.';
      }
      await Promise.all([this.loadReport(), this.getInfoClient()]);
    },
    async loadReport() {
      this.loading = true;
      try {
        if (this.reportData) URL.revokeObjectURL(this.reportData);
        const blob = await internalDossierService.getReportFile(this.stamp, { report_type: this.report });
        if (blob) {
          this.reportData = URL.createObjectURL(blob);
          this.reportBlob = blob;
          this.localShow = true;
        }
      } catch {
        this.$toast.add({ severity: "error", summary: "Erro", detail: "Não foi possível carregar o relatório", life: 3000 });
      } finally {
        this.loading = false;
      }
    },
    async sendEmail() {
      if (!this.clientData.email) return;
      this.sendingEmail = true;
      try {
        await internalDossierService.sendReportEmail(this.stamp, { email: this.clientData.email, report_type: this.report });
        this.$toast.add({ severity: "success", summary: "E-mail enviado", detail: "Relatório enviado com sucesso", life: 3000 });
      } catch {
        this.$toast.add({ severity: "error", summary: "Erro", detail: "Não foi possível enviar o e-mail", life: 3000 });
      } finally {
        this.sendingEmail = false;
      }
    },
    async sendSms() {
      if (!this.clientData.mobilPhone || !this.clientData.smsText) return;
      this.sendingSms = true;
      try {
        await internalDossierService.sendReportSms(this.stamp, {
          phone: this.clientData.mobilPhone,
          text: this.clientData.smsText,
          report_type: this.report
        });
        this.$toast.add({ severity: "success", summary: "SMS enviado", detail: "SMS enviado com sucesso", life: 3000 });
      } catch {
        this.$toast.add({ severity: "error", summary: "Erro", detail: "Não foi possível enviar o SMS", life: 3000 });
      } finally {
        this.sendingSms = false;
      }
    },
    async getInfoClient() {
      try {
        const response = await internalDossierService.getClientInfoForDossier(this.stamp);
        if (response) {
          this.clientData.email = response.email;
          this.clientData.mobilPhone = response.mobilPhone;
        }
      } catch {
        this.$toast.add({ severity: "error", summary: "Erro", detail: "Não foi possível carregar informações do cliente", life: 3000 });
      }
    },
    downloadReport() {
      if (!this.reportBlob) return;
      const url = URL.createObjectURL(this.reportBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = this.filename || 'relatorio.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => URL.revokeObjectURL(url), 100);
    }
  }
};
</script>

<style scoped>
:deep(.report-dialog .p-dialog-header) { display: none; }
:deep(.report-dialog .p-dialog-content) { padding: 0; border-radius: 10px 10px 0 0; }
:deep(.report-dialog .p-dialog-footer) { padding: 0; border-radius: 0 0 10px 10px; }

.report-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #e9ecef;
  background: #fff;
  border-radius: 10px 10px 0 0;
}
.report-header__left {
  display: flex;
  align-items: center;
  gap: 0.875rem;
}
.report-header__icon {
  font-size: 1.75rem;
  color: #e74c3c;
}
.report-header__title {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: #1a1a2e;
}
.report-header__subtitle {
  margin: 0;
  font-size: 0.8rem;
  color: #6c757d;
}
.report-header__close {
  background: none;
  border: none;
  cursor: pointer;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6c757d;
  transition: background 0.2s, color 0.2s;
}
.report-header__close:hover { background: #f1f3f5; color: #1a1a2e; }

.report-body {
  display: flex;
  flex-direction: column;
  background: #f8f9fa;
}

.share-panel {
  background: #fff;
  border-bottom: 1px solid #e9ecef;
  padding: 1rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.share-panel__header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #6c757d;
}
.share-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}
.share-row--sms { align-items: flex-start; }
.share-row__label {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  min-width: 72px;
  font-size: 0.875rem;
  font-weight: 600;
  color: #495057;
}
.share-row__input { flex: 1; min-width: 180px; }
.share-row__inputs { flex: 1; display: flex; flex-direction: column; gap: 0.5rem; min-width: 220px; }
.share-input { width: 100% !important; }
:deep(.share-input .p-inputtext),
:deep(.share-input.p-inputtext) { font-size: 0.875rem; }
.share-btn { white-space: nowrap; }
.share-btn--email { background: #2563eb !important; border-color: #2563eb !important; }
.share-btn--email:hover:not(:disabled) { background: #1d4ed8 !important; border-color: #1d4ed8 !important; }
.share-btn--sms { background: #16a34a !important; border-color: #16a34a !important; }
.share-btn--sms:hover:not(:disabled) { background: #15803d !important; border-color: #15803d !important; }

.pdf-preview { padding: 1.25rem 1.5rem; }
.pdf-frame {
  width: 100%;
  min-height: 580px;
  border: none;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
  background: #fff;
}

.report-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid #e9ecef;
  background: #fff;
}
:deep(.report-footer__download .p-button-label) { font-weight: 600; }
</style>
